var _defs, _rect, _path, _rect2, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalculatorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #2d499b;\n      }\n\n      .cls-1, .cls-3, .cls-4, .cls-5 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2, .cls-6 {\n        stroke: #293681;\n      }\n\n      .cls-3 {\n        fill: #51c7e0;\n      }\n\n      .cls-6 {\n        fill: none;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-4 {\n        fill: #fbb616;\n      }\n\n      .cls-5 {\n        fill: #293681;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 2,
    y: 2,
    width: 15,
    height: 23,
    rx: 0.52,
    ry: 0.52
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M14.71,24.31H2.04c-.26-.01-.46-.22-.46-.48l.02-22.05c0-.26.21-.46.47-.46l14.05.02c.26,0,.46.21.46.47v12.28c.32-.14.65-.27,1-.38V1.33c0-.56-.46-1.02-1.02-1.02H1.59C1.03.31.57.77.57,1.33v22.97c0,.56.46,1.02,1.02,1.02h14.2c-.41-.29-.77-.63-1.09-1Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3.07,
    y: 3.31,
    width: 12,
    height: 5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.57,
    y: 9.81,
    width: 2.17,
    height: 2.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.99,
    y: 9.81,
    width: 2.17,
    height: 2.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.41,
    y: 9.81,
    width: 2.17,
    height: 2.17
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.57,
    y: 15.23,
    width: 2.17,
    height: 2.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.99,
    y: 15.23,
    width: 2.17,
    height: 2.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.41,
    y: 15.23,
    width: 2.17,
    height: 2.17
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.57,
    y: 20.64,
    width: 7.58,
    height: 2.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.41,
    y: 20.64,
    width: 2.17,
    height: 2.17
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M20.37,15.26c-2.97,0-5.38,2.41-5.38,5.38,0,1.27.45,2.44,1.19,3.37.92.74,2.09,1.19,3.36,1.19,2.97,0,5.38-2.41,5.38-5.38,0-1.27-.45-2.44-1.19-3.37-.92-.74-2.09-1.19-3.36-1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M17.89,21.88c.08.11.74.83,1.66.83s1.66-.7,1.66-1.66c0-1.11-1.26-1.53-1.66-1.66-.4-.13-1.24-.56-1.24-1.24s.56-1.24,1.24-1.24c.44,0,.99.23,1.24.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M19.55,23.53v-.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M19.55,16.91v-.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M16.68,15.26c.83-.52,1.81-.83,2.87-.83,2.97,0,5.38,2.41,5.38,5.38s-2.41,5.38-5.38,5.38-5.38-2.41-5.38-5.38c0-1.05.3-2.03.83-2.86"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculatorIcon);
export default __webpack_public_path__ + "static/media/calculator-icon.f1ec0fcdeeeaa35dd4e6dd3e9ba0c179.svg";
export { ForwardRef as ReactComponent };